
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.216 14.378a13.7 13.7 0 00-1.997.134c-2.265.332-4.165 2.636-4.165 5a1.027 1.027 0 11-2.054 0c0-2.662 1.669-5.278 4.066-6.452a7.189 7.189 0 118.3 0c2.397 1.174 4.066 3.79 4.066 6.453a1.027 1.027 0 11-2.054 0c0-2.365-1.9-4.669-4.165-5a13.545 13.545 0 00-1.997-.135zm0-2.054a5.135 5.135 0 110-10.27 5.135 5.135 0 010 10.27z","fill":"#161F27"}})])
          )
        }
      }
    